import { render, staticRenderFns } from "./PdfDoughnut.vue?vue&type=template&id=3842ad74&"
import script from "./PdfDoughnut.vue?vue&type=script&lang=js&"
export * from "./PdfDoughnut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports